import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getBackgroundByTheme(theme: { primary?: string; secondary?: string }) {
  return `radial-gradient(50% 50% at 50% 50%, ${theme.secondary} 0%, ${theme.primary} 100%)`
}

/**
 * Hard-reload the app to `/`. Used after business switch / delete / leave so
 * RTK Query caches, in-memory adapters, and component state can't bleed into
 * a new business context. `assign('/')` is a no-op when already on `/`, so we
 * branch to `reload()` in that case.
 */
export function reloadToRoot(): void {
  if (window.location.pathname !== '/') {
    window.location.href = '/'
    return
  }
  window.location.reload()
}
